import { Injectable, inject } from '@angular/core';

import { Options, Service, create } from '@rtms/client';

import { RtmsConfigService } from './rtms-config.service';
import { RtmsLogService } from './rtms-log.service';
import { RtmsTimerService } from './rtms-timer.service';
import { RtmsConfig } from './rtms.client-config';

@Injectable({
    providedIn: 'root',
})
export class RtmsServiceFactory {
    private readonly rtmsConfig = inject(RtmsConfig);
    private readonly rtmsConfigService = inject(RtmsConfigService);
    private readonly rtmsLogService = inject(RtmsLogService);
    private readonly rtmsTimerService = inject(RtmsTimerService);

    create(): Service {
        return create(
            new Options(this.rtmsConfig.host, this.rtmsConfig.keepAliveMilliseconds, this.rtmsConfig.reconnectMilliseconds),
            this.rtmsConfigService,
            this.rtmsLogService,
            undefined,
            this.rtmsTimerService,
        );
    }
}
